<template>
  <tg-dialog
    ref="dialog"
    :theme="currentTheme"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :showFooter="true"
    :showCancelBtn="true"
    @on-confirm="confirmHandler"
    width="30%"
  >
    <template slot="subject">{{ subject }}</template>

    <template slot="subtitle">
      ({{ actionLabel }}) {{ privilegeLabel }}
    </template>

    <el-alert
      v-show="status == 'close' && hasMemberType"
      type="tg-alert"
      :closable="false"
      center
      show-icon
    >
      <template slot="title">
        <span v-html="$t('component.dialog.privilege.note')"></span>
      </template>
    </el-alert>
  </tg-dialog>
</template>

<script>
import apis from "@/apis";
import TgDialog from "@/components/dialog/TgDialog";
const api = apis.tg_business;

export default {
  inheritAttrs: false,
  components: {
    TgDialog,
  },
  props: {
    filter: Number,
    functional: Array,
    level: Number,
    targetName: String,
    update_target: Boolean,
    status: String,
  },
  computed: {
    currentTheme() {
      return this.status == "close" ? "warning" : "info";
    },
    themeCls() {
      return {
        info: this.currentTheme === "info",
        warning: this.currentTheme === "warning",
      };
    },
    classes() {
      return ["tg-modal", this.themeCls];
    },
    iconClass() {
      return ["tg-modal-icon", this.themeCls];
    },
    subject() {
      let targetName = this.targetName;
      let filter = this.$t("enum.date_filter[" + this.filter + "]");
      let level = this.$t("enum.levels[" + (this.level - 1) + "]");

      let langKey = "component.dialog.subject.privilege_bulk.";

      if (!this.update_target) {
        langKey += "no_target";
      } else {
        langKey += "has_target";
      }

      return this.$t(langKey, { targetName, filter, level });
    },
    actionLabel() {
      let status = this.status == "open" ? 0 : 1;
      return this.$t("component.dialog.status.privilege[" + status + "]");
    },
    privilegeLabel() {
      let label = this.functional.reduce((a, b) => {
        a.push(this.$t("column." + b));
        return a;
      }, []);
      return label.join("、");
    },
    request() {
      return this.$props;
    },
    hasMemberType() {
      return this.functional.find((x) => x == "member_type");
    },
  },
  methods: {
    confirmHandler() {
      const loading = this.$loading({
        lock: true,
        text: "Loading...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      api.member.privilege
        .bulkChangePrivilege(this.request)
        .then((response) => {
          this.$emit("on-changed", response);
          if (this.$refs.dialog) {
            this.$refs.dialog.close();
          }
          loading.close();
        });
    },
  },
};
</script>
